export var DEFAULT_MASK_LEVEL = 'medium';
//# sourceMappingURL=types.js.map